import React, { useEffect } from 'react';
import ComplexCard from '../components/cards/ComplexCard';
import Button from '../components/buttons/Button';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTE_UPDATE_ARENA } from '../router/constants';
import { useComplexes } from '../hooks/useComplexes';
import { COMMON_TRANSLATE_KEYS } from '../constants/translate-keys';
import { useTranslation } from 'react-i18next';

const MyFields = () => {
  const { getComplexes, complexes } = useComplexes();

  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    getComplexes();
  }, [getComplexes]);

  const handleSeeDetails = (arenaId: string) => {
    navigate(`/arena/${arenaId}/info`);
  };

  const onUpdateArena = (id: string | number) => {
    const id_param = id.toString();

    navigate(generatePath(ROUTE_UPDATE_ARENA, { id: id_param }));
  };

  return (
    <div className="px-8 mb-10">
      <h1 className="text-white my-4">
        {t(COMMON_TRANSLATE_KEYS.COMPLEXES, { count: complexes.length })}
      </h1>
      <div className="flex flex-wrap gap-3">
        {complexes.map((complex: any) => {
          return (
            <ComplexCard
              width="lg"
              key={complex.id}
              title={complex.name}
              location={`${complex.city}, ${complex.country}`}
              complex={complex}
            >
              <div className="flex sm:flex-row flex-col justify-between items-center gap-3">
                <Button
                  border="border-mainBlue"
                  backgroundColor="bg-gray-800"
                  textColor="text-mainBlue"
                  onClick={() => handleSeeDetails(complex.id)}
                >
                  {t(COMMON_TRANSLATE_KEYS.SEE_DETAILS)}
                </Button>

                <Button
                  backgroundColor="bg-functionalGreen"
                  textColor="text-gray-800"
                  onClick={() => onUpdateArena(complex.id)}
                >
                  {t(COMMON_TRANSLATE_KEYS.ADD_FIELD)}
                </Button>
              </div>
            </ComplexCard>
          );
        })}
        {complexes.length === 0 && (
          <h1 className="text-textGray font-normal text-xl text-center">
            {t(COMMON_TRANSLATE_KEYS.NO_COMPLEXES_MAIN_PAGE)}
          </h1>
        )}
      </div>
    </div>
  );
};

export default MyFields;
